if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
          prevArrow: this.querySelector('.product__media-arrow--prev'),
          nextArrow: this.querySelector('.product__media-arrow--next'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');

        if (this.elements.prevArrow) {
          this.elements.prevArrow.addEventListener('click', (e) => {
            e.preventDefault();
            this.navigateMedia(-1);
          });
        }
        if (this.elements.nextArrow) {
          this.elements.nextArrow.addEventListener('click', (e) => {
            e.preventDefault();
            this.navigateMedia(1);
          });
        }

        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout && this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      navigateMedia(direction) {
        let targets = [];
        if (this.elements.thumbnails) {
          const thumbItems = Array.from(this.elements.thumbnails.querySelectorAll('[data-target]'))
            .filter((item) => !item.classList.contains('thumbnail-list_item--variant'));
          targets = thumbItems.map((item) => item.dataset.target);
        }

        if (targets.length === 0) {
          const slides = Array.from(this.elements.viewer.querySelectorAll('.product__media-item[data-media-id]'))
            .filter((item) => !item.classList.contains('product__media-item--variant'));
          targets = slides.map((item) => item.dataset.mediaId);
        }

        if (targets.length <= 1) return;

        const currentActiveSlide = this.elements.viewer.querySelector('.product__media-item.is-active');
        const currentMediaId = currentActiveSlide ? currentActiveSlide.dataset.mediaId : targets[0];
        let currentIndex = targets.indexOf(currentMediaId);
        if (currentIndex === -1) currentIndex = 0;

        let nextIndex = currentIndex + direction;
        if (nextIndex < 0) nextIndex = targets.length - 1;
        if (nextIndex >= targets.length) nextIndex = 0;

        this.setActiveMedia(targets[nextIndex], false);
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);

        const ulElement = this.elements.viewer.querySelector('ul');
        if (ulElement) {
          const swiperContainer = ulElement.querySelector('.swiper-container');
          if (swiperContainer) {
            const swiperWrapper = swiperContainer.querySelector('.swiper-wrapper');
            if (swiperWrapper) {
              swiperWrapper.style.setProperty('transform', 'translate3d(0px, 0px, 0px)');
            }
          }
        }

        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('swiper-slide-active');
          element.classList.remove('is-active');
        });
        activeMedia.classList.add('swiper-slide-active');
        activeMedia.classList.add('is-active');
        
        if (prepend) {
          activeMedia.parentElement.prepend(activeMedia);
          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            if (activeThumbnail && activeThumbnail.parentElement) {
              activeThumbnail.parentElement.prepend(activeThumbnail);
            }
          }
          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        if (activeThumbnail && activeThumbnail.dataset) {
          this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
        }
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;
        this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
        const btn = thumbnail.querySelector('button');
        if (btn) btn.setAttribute('aria-current', true);
        thumbnail.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}